import { Component, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model'

@Injectable()
export class EntityOtherService {
  private entityId: BehaviorSubject<EntityIdDetails>;

  constructor() {
    this.entityId = new BehaviorSubject<EntityIdDetails>(new EntityIdDetails());
  }

  onEntityIdChanged(): Observable<any> {
    return this.entityId.asObservable();
  }

  setEntityId(entityId: EntityIdDetails) {
    this.entityId.next(entityId);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/other/entity-other.service.ts